module.exports = __webpack_public_path__ + "static/img/immunization-academy.6095c98.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/immunization-academy.png
// module id = 939
// module chunks = 2 8